import React from 'react'
import LinearGradient from 'react-native-linear-gradient'
import { useBaseLayoutStyle } from '../../../ions/styles'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle } = helpers

export const LinearGradientContainer = ({ colors, minimized, horizontal = false, style, ...props }) => {
  const { container, minimized: minimizedStyle } = useBaseLayoutStyle()
  return <LinearGradient
    style={composeStyle(container, minimized && minimizedStyle, style)} start={horizontal && { x: 0, y: 0 }}
    end={horizontal && { x: 1, y: 0 }} colors={colors} {...props} />
}
